export default "__VITE_ASSET__5a0a04db__"